export class GermanUfValuesSlidingDoor {
  systemName: string;
  profileCombination: string | null;
  uf: number | null;

  constructor(row: Record<string, string | number | null>) {
    this.systemName = row['systemName'] as string;
    this.profileCombination = row['profileCombination'] as string | null;
    this.uf = row['uf'] as number | null;
  }
}